import * as yup from "yup";
import {TransferTypes} from "../../../app/models/transfer-type";
import {status} from "./order-form-behaviour";

// Id = "";
//   Reference = "";
//   Sub = "";

//   SendingCurrencyCode = "";
//   SendingCurrencyLabel = "";
//   SendingCurrencySymbol = "";
//   SendingAmount = undefined;
//   SendingCoutryLabel='';
//   SendingCoutryCode='';

//   ReceivingCurrencyCode = "";
//   ReceivingCurrencyLabel = "";
//   ReceivingCurrencySymbol = "";
//   ReceivingAmount = undefined;
//   ReceivingCoutryLabel='';
//   ReceivingCoutryCode='';

//   CreatedByUserName = "";
//   CreatedByUserSub = "";
//   CreatedByName='';

//   ExchangeType = "";
//   DeliveryType = "";

//   DeliveryBankAccount = "";
//   DeliveryBank = "";
//   DeliveryBankBranch = "";

//   PaidByUserName?='';
//   PaidBySub?='';
//   PaidByName='';

//   DeliveryOffice = "";

//   status = "";

//   RemitterName = '';
//   RemitterEmail = '';
//   RemitterPhone = '';

//   BeneficiaryName = '';
//   BeneficiaryEmail = '';
//   BeneficiaryPhone = '';
const FullName = /\w+\s{1}\w+\s{1}\w+/;

export const orderFormSchema = yup.object().shape({
    Id: yup.string().required("Order Id was not genereted"),
    Reference: yup.string().required("Order reference was not generated"),
    CreatedByUserSub: yup.string().required("User Sub have not been set"),
    CreatedByUserName: yup.string().required("Username have not been set"),
    CreatedByName: yup.string().required("Name have not been set"),
    ExchangeType: yup.string().required("Currency Exchange type is not selected"),
    SendingAmount: yup
        .number()
        .required("Sending amount cannot be left blank")
        .moreThan(0, "Sending amount cannot be zero"),
    ReceivingAmount: yup
        .number()
        .required("Receiving amount cannot be left blank"),
    DeliveryType: yup
        .string()
        .required("Transfer type cannot be left unselected"),
    RemitterName: yup.string().label('Full Name').min(6).matches(FullName,{message:"Please inter remitter name , father name and grand father name"}).required("Remitter name cannot be left blank"),
    //RemitterEmail: yup.string().required("Remitter Email cannot be left blank"),
    RemitterPhone: yup.number().required("Remitter Phone cannot be left blank"),
    BeneficiaryName: yup
        .string().min(6).matches(FullName,{message:"Please inter receiver name , father name and grand father name"})
        .required("Beneficiary name cannot be left blank"),
    /*BeneficiaryEmail: yup
      .string()
      .required("Beneficiary email cannot be left blank"),*/
    BeneficiaryPhone: yup
        .string()
        .required("Beneficiary Phone cannot be left blank"),

    /* Notes: yup.string().when('Status', {
         is: (Status: string) => {
             return parseInt(Status) === 1
         },
         then: yup.string().required("Notes are required to be filled in").min(1),
         otherwise: yup.string().nullable(true)
     }),*/
    //Notes: yup.string().required('Requied').min(1),
    DeliveryOffice: yup.string().when("DeliveryType", {
        is: (DeliveryType) => DeliveryType === TransferTypes.cash.toString(),
        then: yup.string().required("Pick office is not specified"),
        otherwise: yup.string().nullable(true)
    }),
    Fees: yup.number().when(['ReceivingCurrencyCode', 'SendingCurrencyCode'], {
        is: (ReceivingCurrencyCode, SendingCurrencyCode) => {
            console.log(ReceivingCurrencyCode, SendingCurrencyCode)
            return ReceivingCurrencyCode === SendingCurrencyCode
        },
        then: yup.number().required('Fees cannot be left blank'),
        otherwise: yup.number().nullable(true)
    }),
    DeliveryBank: yup.string().when("DeliveryType", {
        is: (DeliveryType) => DeliveryType === TransferTypes.bank.toString(),
        then: yup.string().required("Bank is not specified"),
        otherwise: yup.string().nullable(true)
    }),
    DeliveryBankBranch: yup.string().when("DeliveryType", {
        is: (DeliveryType) => DeliveryType === TransferTypes.bank.toString(),
        then: yup.string().required("Bank branch is not specified"),
        otherwise: yup.string().nullable(true)
    }),
    DeliveryBankAccount: yup.string().when("DeliveryType", {
        is: (DeliveryType) => DeliveryType === TransferTypes.bank.toString(),
        then: yup.string().required("Bank acount is not specified"),
        otherwise: yup.string().nullable(true)
    }),
    TypeOfID: yup.string().when(['Status', 'DeliveryType'], {
        is: (Status: string, type : string) => {
            return (status(Status) === "ReadyForCollection" && type==='1')
        },
        then: yup.string().required('Type of Id is not specified').nullable(),
        otherwise: yup.string().nullable(true)
    }),
    IDNumber : yup.string().when(['Status', 'DeliveryType'],{
        is: (Status: string, type : string) => {
            return (status(Status) === "ReadyForCollection" && type==='1')
        },
        then: yup.string().required('ID Number is not specified').nullable(),
        otherwise: yup.string().nullable(true)
    }),
    IssueDate : yup.string().when(['Status', 'DeliveryType'],{
        is: (Status: string, type : string) => {
            return (status(Status) === "ReadyForCollection" && type==='1')
        },
        then: yup.string().required('Issue Date is not specified').nullable(),
        otherwise: yup.string().nullable(true)
    }),
    IssuePlace : yup.string().when(['Status', 'DeliveryType'],{
        is: (Status: string, type : string) => {
            return (status(Status) === "ReadyForCollection" && type==='1')
        },
        then: yup.string().required('Issue Place is not specified').nullable(),
        otherwise: yup.string().nullable(true)
    }),
    Address : yup.string().when(['Status', 'DeliveryType'],{
        is: (Status: string, type : string) => {
            return (status(Status) === "ReadyForCollection" && type==='1')
        },
        then: yup.string().required('Address is not specified').nullable(),
        otherwise: yup.string().nullable(true)
    }),
});
